import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';
import { Chip, Typography } from '@navi/web-ui/lib/primitives';
import React from 'react';
import { Control, Controller, FieldErrorsImpl, RegisterOptions } from 'react-hook-form';
import cx from 'classnames';
import { AgentFormValues } from '../../interfaces/types';
import { AGENT_BANDWIDTH_OPTIONS } from '../../constants/constants';

type AgentFormRadioChipProps = {
  control: Control<AgentFormValues>;
  name: keyof AgentFormValues;
  rules: RegisterOptions;
  errors: Partial<FieldErrorsImpl<AgentFormValues>>;
  styles: CSSModuleClasses;
  inputLabel: string;
  validationMessage?: string;
  showRequiredIcon?: boolean;
  defaultValue?: string;
  isEditDisabled?: boolean;
};

const AgentFormRadioChip: React.FC<AgentFormRadioChipProps> = props => {
  const {
    control,
    name,
    rules,
    errors,
    styles,
    inputLabel,
    showRequiredIcon = true,
    validationMessage = '',
    defaultValue = '',
    isEditDisabled = false
  } = props;

  const [selectedRadioChipOption, setSelectedRadioChipOption] =
    React.useState<string>(defaultValue);

  const handleRadioChipChange = (value: string) => {
    if (isEditDisabled) return;
    setSelectedRadioChipOption(value);
  };

  return (
    <>
      <div className={cx(styles.textContainer, 'pb-1')}>
        <Typography variant="p4" color="var(--navi-color-gray-c2)">
          {inputLabel}
        </Typography>
        {showRequiredIcon ? <RequiredIcon /> : null}
      </div>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value, ref } }) => (
          <div className={styles.radioChipContainer}>
            {AGENT_BANDWIDTH_OPTIONS.map(option => (
              <Chip
                key={option.id}
                label={option.label}
                selected={selectedRadioChipOption === option?.value}
                onChipClick={() => {
                  onChange(option?.value);
                  handleRadioChipChange(option?.value);
                }}
                wrapperClasses="mr-4"
                disabled={isEditDisabled}
              />
            ))}
          </div>
        )}
      />

      {errors && errors[name] && (
        <div className={styles.errorContainer}>
          <ErrorIconOutline />
          <Typography variant="p4" className={styles.errorText}>
            {validationMessage}
          </Typography>
        </div>
      )}
    </>
  );
};

export default AgentFormRadioChip;
